export const hcoDcrModalContentStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 3
	}
};
